import "../css/app.css";

// Put Alpine last, so that it has access to other JS modules
import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}

// require("fslightbox");

// document.addEventListener("DOMContentLoaded", function () {
//   refreshFsLightbox();
// });

// LazySizes
import "lazysizes";

// SwiperJS
import Swiper from "swiper/bundle";
// import Swiper styles
import "swiper/css/bundle";
// import 'simplelight-box.css';
window.Swiper = Swiper;

var swiper = new Swiper(".product-swiper", {
  slidesPerView: 2.5,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

swiper.on("slideChange", function () {
  console.log("slide changed");
});
const gallerySlider = new Swiper(".gallery-slider", {
  slidesPerView: 1,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  speed: 300,
  slidesPerView: "auto",
  loop: true,
});

document.addEventListener('DOMContentLoaded', () => {
//check how many .slide elements are in the .images-slider
let numberOfSlides = document.querySelectorAll(
  ".images-slider .swiper-slide"
).length;
  const sliderEl = document.querySelector('.images-slider');
  
if (window.innerWidth < 1024) {
  const imagesSlider = new Swiper(".images-slider", {
    slidesPerView: 'auto',
    loop: true,
    speed: 6000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
  },
    spaceBetween: 10,
    breakpoints: {
      1024: {
        init: false,
        allowTouchMove: true,
      },
    },
  });
} else {
  const imagesSlider = new Swiper(".images-slider", {
    slidesPerView: 'auto',
    loop: true,
    speed: 6000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
      waitForTransition: false,
    },
     navigation: {
       nextEl: ".swiper-button-next",
       prevEl: ".swiper-button-prev",
     },
    spaceBetween: 20,
  });
}

sliderEl.addEventListener('mouseenter', () => imagesSlider.autoplay.stop());
sliderEl.addEventListener('mouseleave', () => imagesSlider.autoplay.start());
  
const nextBtn = document.querySelector(".swiper-button-next");
const prevBtn = document.querySelector(".swiper-button-prev");

const SNAP = 0;
const BASE_SPEED = imagesSlider.params.speed;

 function snap(dir) {
    if (imagesSlider.animating) {
      imagesSlider.setTransition(0);
    }
    imagesSlider.params.speed = 0;

 if (dir === 1) {
      imagesSlider.slideToLoop(imagesSlider.realIndex + 1, SNAP, false);
    } else {
      imagesSlider.slideToLoop(imagesSlider.realIndex - 1, SNAP, false);
 }
   imagesSlider.params.speed = BASE_SPEED;

    if (imagesSlider.autoplay && imagesSlider.autoplay.running === false) {
      imagesSlider.autoplay.start();
    }
 }

  function blockAndSnapNext(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    snap(1);
  }
  function blockAndSnapPrev(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    snap(-1);
  }

  ['pointerdown', 'click'].forEach(evt => {
    nextBtn?.addEventListener(evt, blockAndSnapNext, true);
    prevBtn?.addEventListener(evt, blockAndSnapPrev, true);
  });

});
  
document.body.addEventListener('htmx:afterSwap', (e) => {

  const target = e.detail && e.detail.target;
  if (!target || target.id !== 'news-grid') return;

  const items = target.querySelectorAll('.news-item:not(.is-in)');

  requestAnimationFrame(() => {
    items.forEach((el, i) => {
      setTimeout(() => el.classList.add('is-in'), i * 40); 
    });
  });
});

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('#news-grid .news-item').forEach((el, i) => {
    setTimeout(() => el.classList.add('is-in'), i * 40);
  });
});